<template>
    <div class="basic">
        <!-- <van-radio-group v-model="single"> -->
        <div class="top-title disFlex">
            <div class="disFlex">
                <div class="line"></div>
                <div>Select the cooperation Level</div>
            </div>
            <div>
                <van-radio-group v-model="single" @change="changmethod">
                    <van-radio name="已选择1" @click="radioClick1">Selected</van-radio>
                </van-radio-group>
            </div>
        </div>
        <!-- <div style="color: #666666;font-size: 10px;padding:10px 10px">(Gray option is sold out, not selectable)
                </div> -->
        <div style="padding: 10px 20px;">
            <div :gutter="24" style=" display: flex;flex-wrap: wrap;">
                <div v-for="(item, index) in listPavilion" :key="index" style="padding: 10px; ">
                    <!-- <van-button type="default" size="small"  @click="butChange(item,index)" :class="activeBut === index?'buttonCss':''" :disabled="item.tname=='首席'" >{{item.tname}}</van-button> -->
                    <div class="butButCss" style="background-color: #e6e6e6;color: #999999;" v-if="item.tname == 'Chief'">
                        Chief</div>
                    <div class="butButCss" @click="butChange(item, index)" :class="activeBut === index ? 'buttonCss' : ''"
                        v-if="item.tname != 'Chief'">{{
                            item.tname
                        }}
                    </div>
                </div>
            </div>

            <div class="listPavilionDiv" v-for="(item, index) in showListDiv" :key="index">
                <p>{{ item.text0 }}</p>
                <p>{{ item.text1 }}</p>
                <p>{{ item.text2 }}</p>
                <p>{{ item.text3 }}</p>
            </div>
        </div>

        <div class="gap"></div>

        <div class="top-title disFlex">
            <div class="disFlex">
                <div class="line"></div>
                <div>Select an exhibition area</div>
            </div>
            <div>
                <van-radio-group v-model="single" @change="changmethod1">
                    <van-radio name="已选择2" @click="radioClick2">Selected</van-radio>
                </van-radio-group>
            </div>
        </div>
        <!-- <van-field v-model="formInline.linkMan" name="linkMan" label="Select an exhibition area"
                    placeholder="Please select" /> -->

        <van-field readonly clickable label="Select an exhibition area" :value="exVal" label-width="160px"
            placeholder="Please select" @click="showPickerEx = true" />
        <van-popup v-model="showPickerEx" round position="bottom">
            <van-picker show-toolbar :columns="exAreaListInit" @cancel="showPickerEx = false"
                @confirm="onConfirmSelectEx" />
        </van-popup>

        <p style="color: #666666;font-size: 10px;padding:10px 10px">Please select the corresponding exhibition
            area according to the industry of the company you entered</p>
        <div style="padding: 10px;">
            <van-radio-group v-model="animal">
                <van-radio name="光地" @click="onConfirmSelectEx(exVal)" :disabled="sponsorDis">Raw space: 2100/㎡
                    (from 18㎡)</van-radio>
                <van-radio name="标展" @click="onConfirmSelectEx(exVal)" :disabled="sponsorDis"
                    style="margin-top: 15px;">Standard Booth: 2300/㎡ (from 12㎡)</van-radio>
            </van-radio-group>

            <p style="margin-top: 15px;"> Reserved area<InputNumber :max="99999999999" :min="1" v-model="value1"
                    @on-change="areaInputChange" :disabled="sponsorDis" style="margin-left: 10px;" placeholder="请输入">
                </InputNumber> ㎡ </p>
        </div>
        <!-- </van-radio-group> -->
        <!-- <div style="margin: 16px;">
        <van-button round block type="info" native-type="submit">提交</van-button>
      </div> -->
        </van-form>
    </div>
</template>

<script>
import { Toast } from 'vant';
import { mapGetters, mapActions } from "vuex";
import country from "@assets/js/country2-en";
export default {
    name: "register-form", // 参展申请 - 基本信息 
    data () {
        const that = this;
        // 判断英文
        const enValid = (value, callback) => {
            if (!value) {
                return true;
            } else {
                if (/^([a-zA-Z]+\s)*[a-zA-Z]+$/.test(value)) {
                    return true;
                } else {
                    return false;
                }
            }
        };
        const companyAddressValid = (value) => {
            // if (that.formInline.addresss.country && that.formInline.addresss.country === 'China') { // China 判断省份和城市是否选择
            //     if (!that.formInline.addresss.province) {
            //         return false;
            //     } else if (!that.formInline.addresss.city) {
            //         return false;
            //     } else {
            //         return true;
            //     }
            // } else {
            if (that.formInline.addresss.country) {
                return true;
            }
            //  else {
            //     return false;
            // }
            // }
        };

        const validEmail = (value, callback) => {
            if (!value) {
                return false;
            } else if (/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(value)) {
                return true;
            } else {
                return false;
            }
        };
        return {
            areaList: [],
            showPicker: false,
            showPicker2: false,
            showPickerIndustry: false,
            cityCode: '',  //省市区编号，默认
            loading: false,
            isInvoice: false,
            formInline: {
                // 企业基本信息 
                linkFax: "",
                companyName: "",// 公司英文名称 
                companyNameShort: "",// 公司简称
                address: "", // 详细地址
                selectAddresTxt: '',
                addresss: {
                    country: "", // 国家
                    province: "", // 省份
                    city: "", // 城市
                    county: "", // 区县 
                },
                // 展会联系人
                linkMan: "",
                linkTitle: "",
                linkEmail: "",
                linkMob: "", // 电话号码 
                industry: "",
                highlightProducts: "",
            },
            formInline1: {
                // 企业基本信息 
                linkFax: "a",
                companyName: "asd",// 公司英文名称 
                companyNameShort: "aaa",// 公司简称
                address: "ssdsa", // 详细地址
                selectAddresTxt: 'sda',
                addresss: {
                    country: "China", // 国家
                    province: "", // 省份
                    city: "", // 城市
                    county: "", // 区县 
                },
                // 展会联系人
                linkMan: "sad",
                linkTitle: "sda萨达",
                linkEmail: "1164232225@qq.com",
                linkMob: "17630757850", // 电话号码 
                industry: "123",
                highlightProducts: "dsad",
            },
            ruleInline: {
                // 企业基本信息  
                companyName: [{ required: true, message: "Please enter the enterprise name", trigger: "onBlur" }],
                companyNameShort: [{ required: true, message: "Please enter the abbreviation", trigger: "onBlur" }],
                selectAddresTxt: [{ required: true, message: "Please enter the address", trigger: "onBlur" }],

                address: [
                    { required: true, message: "Please enter the address", trigger: "onBlur" },
                ],

                // 展会联系人
                linkMan: [{ required: true, message: "Please enter the name", trigger: "onBlur" }],
                linkTitle: [{ required: true, message: "Please enter the position", trigger: "onBlur" }],
                linkMob: [
                    { required: true, message: "Please enter the phone", trigger: "onBlur" },
                    // { validator: validPhone, message: "phone format is not correct!", trigger: "onBlur" },
                ],
                linkEmail: [
                    {
                        validator: validEmail, message: 'E-mail format is not correct!', trigger: "onBlur"
                    }
                ],
                industry: [{ required: true, message: "Please enter the Industry", trigger: "onBlur" }],
                highlightProducts: [{ required: true, message: "Please enter the highlightProducts", trigger: "onBlur" }],


            },

            countryList: [],
            provinceArr: [],
            citiesArr: [],



            selectAddresTxt2: '',
            listPavilion: [
                // { tname: "Chief", list: [{ text0: '',text1: 'Price：1.9 million RMB', text2: 'Area：180 square meters', text3: 'Other interests：Advertising, listing, media, speech and other services（Please call +86 15101626947 for details' }] },
                // { tname: "Strategic Partner", list: [{ text0: 'Quantity of cooperation: limited to 3 companies',text1: 'Cooperation minimum price: 1.4 million RMB', text2: 'Minimum booth area: 180 square meters', text3: 'Other rights and interests: VIP booth, advertising, listing, media, speech and other services, etc' }] },
                // { tname: "Assisting Unit", list: [{ text0: 'Quantity of cooperation: limited to 3 companies', text1: 'Cooperation minimum price: 1 million RMB', text2: 'Cooperation minimum price: 1 million RMB', text3: 'Other rights and interests: VIP booth, advertising, listing, media, speech and other services, etc' }] },
                // { tname: "Support Unit", list: [{  text0: 'Quantity of cooperation: limited to 15 companies',text1: 'Cooperation minimum price: 650,000 RMB', text2: 'Minimum booth area: 150 square meters', text3: 'Other rights and interests: VIP booth, advertising, listing, media, speech and other services, etc' }] },
                // { tname: "Honorary Sponsorship A", list: [{ text0: 'Quantity of cooperation: limited to 40 companies', text1: 'Cooperation minimum price: 330,000 RMB', text2: 'Minimum booth area: 120 square meters', text3: 'Other rights and interests: VIP booth, advertising, listing, media, speech and other services, etc' }] },
                // { tname: "Honorary sponsorship B", list: [{ text0: 'Quantity of cooperation: limited to 40 companies', text1: 'Cooperation minimum price: 330,000 RMB', text2: 'Minimum booth area: 120 square meters', text3: 'Other rights and interests: VIP booth, advertising, listing, media and other services, etc' }] },
                // { tname: "Honorary sponsorship C", list: [{ text0: 'Quantity of cooperation: limited to 40 companies', text1: 'Cooperation minimum price: 220,000 RMB', text2: 'Minimum booth area: 60 square meters', text3: 'Other rights and interests: VIP booth, advertising, listing, media, speech and other services, etc' }] },
                // { tname: "Honorary sponsorship D", list: [{ text0: 'Quantity of cooperation: limited to 40 companies', text1: 'Cooperation minimum price: 220,000 RMB', text2: 'Minimum booth area: 60 square meters', text3: 'Other rights and interests: VIP booth, advertising, listing, media and other services, etc' }] },
                // { tname: "Raw space", list: [{ text0: '2100 RMB / ㎡, Minimum booth area ：18 ㎡, only a empty space' }] },
                // { tname: "Standard booth", list: [{ text0: '2300 RMB / ㎡, Minimum booth area ： 12 ㎡, including basic furniture, carpet, lighting, socket, lintel board' }] },
                // { tname: "CHCC Hospital Construction Award", list: [{ text0: 'CHCC Hospital Construction Award strategic partner enterprise' }] },
                // { tname: "Cooperation in special forums", list: [{ text0: 'Enterprise special forum (Assisting unit)/forum support companies）' }] },
                // { tname: "Speech", list: [] },
                // { tname: "Media cooperation", list: [] },
                // { tname: "Advertising cooperation", list: [] },

                { tname: "Chief strategic cooperation", list: [{ text0: 'Quantity of cooperation: Exclusive', text1: 'Cooperation minimum price: 1.2million RMB', text2: 'Minimum booth area: 180 square meters', text3: 'Other rights and interests: VIP booth, advertising, listing, media, speech and other services, etc' }] },
                { tname: "Strategic cooperation", list: [{ text0: 'Quantity of cooperation: limited to 2 companies', text1: 'Cooperation minimum price: 900,000 RMB', text2: 'Minimum booth area: 150 square meters', text3: 'Other rights and interests: VIP booth, advertising, listing, media, speech and other services, etc' }] },
                { tname: "Assisting Unit", list: [{ text0: 'Quantity of cooperation: limited to 3 companies', text1: 'Cooperation minimum price: 600,000 RMB', text2: 'Minimum booth area: 120 square meters', text3: 'Other rights and interests: VIP booth, advertising, listing, media, speech and other services, etc' }] },
                { tname: "Supporting units", list: [{ text0: 'Quantity of cooperation: limited to 15 companies', text1: 'Cooperation minimum price: 300,000 RMB', text2: 'Minimum booth area: 90 square meters', text3: 'Other rights and interests: VIP booth, advertising, listing, media and other services, etc' }] },
                { tname: "Honorary Sponsorship", list: [{ text0: 'Quantity of cooperation: limited to 20 companies', text1: 'Cooperation minimum price: 200,000 RMB', text2: 'Minimum booth area: 60 square meters', text3: 'Other rights and interests: VIP booth, advertising and other services, etc' }] },

                // { tname: "Raw space", list: [{ text0: '2100 RMB / ㎡, Minimum booth area ：18 ㎡, only a empty space' }] },
                // { tname: "Standard booth", list: [{ text0: '2300 RMB / ㎡, Minimum booth area ： 12 ㎡, including basic furniture, carpet, lighting, socket, lintel board' }] },
                { tname: "Special Forum cooperation", list: [{ text0: 'Enterprise special forum (Assisting unit)/forum support companies）' }] },



            ],
            showListDiv: [],
            animal: '已选择1',
            single: '',
            value1: 1,
            value: 1,
            valueIndustry: '',
            activeBut: '',
            showPickerAdd: false,
            columns: ['杭州', '宁波', '温州', '绍兴', '湖州', '嘉兴', '金华', '衢州'],
            exVal: "",
            sponsorVal: "",
            showPickerEx: false,
            sponsorDis: true,
            exAreaList: [],
            cityList: [],
            exAreaListInit: [],
            cityListInit: [],
            transferList: [],
            ischange1: false,
            ischange: false

        };
    },
    computed: {
        ...mapGetters({
            formHeaders: "getFormHeaders",
            uploadUrl: "getUploadUrl",
            company: "getCompany",
        }),
    },
    created () {
        this.initExArea()
        this.initAllHy()
        this.areaList = country;
    },
    methods: {
        ...mapActions({
            getAllExArea: "releaseModule/getAllExArea", //获取展区和订单
            getAllHy: "releaseModule/getAllHy", //获取行业

            getCityByParentId: "exhibitionModule/getCityByParentId",
        }),

        async initExArea () {
            let opt = {
                clientId: "23",
                languageType: "英文"
            };


            // this.exAreaList = await this.getAllExArea(opt);
            let list = await this.getAllExArea(opt);
            this.exAreaList = list
            list.map(e => {
                this.exAreaListInit.push(e.name)
            })

        },
        // 行业
        async initAllHy () {
            let opt = {
                groupId: "11"
            };

            // this.cityList = await this.getAllHy(opt);
            let list = await this.getAllHy(opt);
            this.cityList = list
            list.map(e => {
                this.cityListInit.push(e.hyxzEn)
            })
        },

        getvalidate (prop, status, error) {
            if (status == false) {
                let opt = {
                    prop: prop,
                    status: status,
                };
                this.validateList.push(opt);
            }
        },
        validForm (name) {
            // 验证表单
            return new Promise((resolve, reject) => {
                this.$refs[name].validate((valid) => {
                    console.log(valid, "valid");
                    resolve(valid);
                });
            });
        },
        //校验邮箱格式
        checkEmail (email) {
            return RegExp(/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/).test(email)
        },

        async handleSubmit () {

            Toast.loading('loading...');
            setTimeout(() => {
                Toast.clear();
            }, 5000);
            let res = await this.validateHandle();
            console.log('res', res);
            return Promise.resolve(res)
        },
        async validateHandle () {

            return new Promise((resolve, reject) => {
                // this.$refs.basicForm.validate().then(() => {

                // 营业执照
                // let valid = true;

                // let form = this.formInline;
                // let formValue = {
                //     companyName: form.companyName,
                //     companyNameShort: form.companyNameShort,
                //     // selectAddresTxt: form.selectAddresTxt,
                //     address: form.address,
                //     country: form.selectAddresTxt,
                //     province: form.addresss.province,
                //     city: form.addresss.city,
                //     county: form.addresss.county,

                //     // 展会联系人
                //     linkMan: form.linkMan,
                //     linkTitle: form.linkTitle,
                //     linkTelephone: form.linkMob, // 电话号码 
                //     linkEmail: form.linkEmail,

                //     typeBusiness: form.industry,
                //     productName: form.highlightProducts,

                //     supportType: this.single=='已选择1'?this.sponsorVal:'',
                // }
                Toast.clear();
                // if (!valid) {
                //     Toast.fail("Errors in forms submitted, please re-submit.");
                //     return
                // }
                // if (!this.single) {
                //     this.$Notice.warning({ title: `Please select the booth reservation information` });
                //     return
                // } else {
                if (this.single == '已选择1') {
                    if (!this.sponsorVal) {
                        this.$Notice.warning({ title: `Please select the Type of cooperation` });
                        return
                    }
                }
                if (this.single == '已选择2') {
                    if (!this.exVal) {
                        this.$Notice.warning({ title: `Please select exhibition area` });
                        return
                    }
                    if (!this.exVal) {
                        this.$Notice.warning({ title: `Please select exhibition area` });
                        return
                    }
                    if (!this.animal) {
                        this.$Notice.error('Please select light ground/standard exhibition');
                        return
                    }
                }
                // }
                if (this.formInline.linkEmail) {
                    if (!this.checkEmail(this.formInline.linkEmail)) {
                        this.$Notice.error('Please fill in the correct email');
                        return
                    }
                }
                if (this.single == '已选择2') {
                    this.transferList = []
                    let order = {}
                    order.areaName = this.exVal //订单名称
                    order.areaType = this.animal //展区（订单）类别
                    order.pType = 'RMB' //币种
                    order.showArea = this.value1	//预定面积
                    this.transferList.push(order)
                    console.log(this.transferList);
                }

                resolve({ lists: this.transferList, });
                // }).catch(() => {
                //     //验证失败 
                //     Toast.clear();
                //     Toast.fail("Errors in forms submitted, please re-submit.");
                //     resolve({ valid: false, form: null });
                // })
            });
        },
        onConfirm (value) {
            // this.formInline.addresss.country = value[0] || '';
            // this.formInline.addresss.province = value[1] || '';
            // this.formInline.addresss.city = value[2] || '';
            // this.formInline.addresss.county = value[3] || '';
            // this.selectAddresTxt = `${this.formInline.addresss.country ? this.formInline.addresss.country : ''}${this.formInline.addresss.province ? '/' + this.formInline.addresss.province : ''}${this.formInline.addresss.city ? '/' + this.formInline.addresss.city : ''}${this.formInline.addresss.county ? this.formInline.addresss.county : ''}`;
            this.formInline.selectAddresTxt = value.text
            this.showPicker = false;
        },
        areaInputChange (e) {
            this.activeBut=''
            if (this.exVal) {
                this.transferList[0].showArea = e
                this.transferList[0].hallCount = e
                this.transferList[0].applyBoothOrder.area = e
            } else {
                this.value1 = e
            }

        },
        // 选择战区
        butChange (e, index) {
            this.sponsorVal = e.tname
            this.showListDiv = e.list
            this.activeBut = index
            this.single = '已选择1'
            this.sponsorDis = true
            this.value1 = 0
            this.animal = ''
            this.transferList = []
            let order = {}
            order.areaName = e.tname //订单名称
            order.areaType = '标展' //展区（订单）类别
            order.pType = 'RMB' //币种
            order.showArea = 1	//预定面积
            this.transferList.push(order)
            console.log(this.transferList);

            // this.transferList = []
            // let order = {}
            // this.exAreaList.map(i => {
            //     if (i.name == 'VIP Exhibition Area') {
            //         this.exVal = i.name
            //         i.pjNames.map(j => {
            //             if (j.pjName.indexOf(e.tname) != -1) {
            //             // if (j.pjName == e.tname) {
            //                 order.hallCount = 1//展位数量
            //                 order.pType = j.pType //币种
            //                 order.showArea = j.standstall	//预定面积
            //                 order.allMoney = j.price	//总价
            //                 order.applyBoothOrder = {
            //                     boothType: j.boothType,
            //                     unit: j.cunit,
            //                     dePjNameGroupId: i.id,
            //                     gpName: j.gpName,
            //                     groupId: j.groupId,
            //                     dePjNameGroupName: i.name,
            //                     pjCode: j.pjCode,
            //                     pjFormat: j.pjFormat,
            //                     unitPrice: j.price,
            //                     monetaryUnit: j.pType,
            //                     name: j.pjName,
            //                     area: j.standstall,
            //                 }


            //             // }
            //             }
            //         })
            //     }
            // })
            // this.transferList.push(order)
        },
        changmethod () {
            this.ischange = true
        },
        changmethod1 () {
            this.ischange1 = true
        },

        radioClick1 (e) {
            this.sponsorDis = true
            this.value1 = 0
            this.animal = ''
            this.isSelect = this.ischange ? this.single = '已选择1' : this.single = ''
            this.ischange = false
        },
        radioClick2 (e) {
            this.isSelect = this.ischange1 ? this.single = '已选择2' : this.single = ''
            this.ischange1 = false
            this.sponsorDis = false
            this.activeBut = 20
        },
        onConfirmSelectEx (value) {
            this.activeBut=''

            this.single = '已选择2'
            this.sponsorDis = false


            this.exVal = value;
            this.showPickerEx = false;
            this.transferList = []
            let order = {}



            this.exAreaList.map(i => {
                if (i.name == value) {
                    i.pjNames.map(j => {
                        if (j.boothType == this.animal) {
                            this.value1 = j.standstall
                            order.hallCount = 1 //展位数量
                            order.pType = j.pType //币种
                            order.showArea = this.value1	//预定面积
                            order.allMoney = j.price	//总价
                            order.applyBoothOrder = {
                                boothType: j.boothType,
                                unit: j.cunit,
                                dePjNameGroupId: i.id,
                                gpName: j.gpName,
                                groupId: j.groupId,
                                dePjNameGroupName: i.name,
                                pjCode: j.pjCode,
                                pjFormat: j.pjFormat,
                                unitPrice: j.price,
                                monetaryUnit: j.pType,
                                name: j.pjName,
                                area: this.value1
                            }

                        }
                    })
                }
            })
            this.transferList.push(order)

        },

        onConfirmAdd (value) {
            this.valueAdd = value;
            this.showPickerAdd = false;
        },
        onConfirmIndustry (value) {
            this.formInline.industry = value;
            this.showPickerIndustry = false;
        },
        onConfirmExVal (value) {
            this.exVal = value;
            this.showPickerEx = false;
        },
    },
};
</script>

<style scoped lang='scss'>
.basic {
    background-color: #ffff;

    /deep/ {
        .ivu-radio-checked .ivu-radio-inner {
            border-color: #1e88e5 !important;
        }

        .van-switch--on,
        .ivu-radio-inner:after {
            background-color: #1e88e5;
        }

        .van-button--info,
        .van-radio__icon--checked .van-icon,
        .ivu-switch-checked {
            border-color: #1e88e5;
            background-color: #1e88e5;
        }
    }

    &-header {
        width: 100%;
        height: 48px;
        background-color: #1e88e5;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;

        p {
            line-height: 48px;
            font-size: 15px;
        }

        span {
            width: 30px;
            height: 15px;
            background-color: #fff;
            margin: 0 15px;
        }
    }

    &-name {
        padding: 30px 0 10px 30px;
        background-color: #fff;
    }

    &-address {
        padding: 30px 0 10px 30px;
        background-color: #ededed;
    }

    &-phone {
        padding: 30px 0 10px 30px;
        background-color: #fff;
    }

    &-license {
        padding: 30px 0 10px 30px;
        background-color: #ededed;
    }

    .upload-btn {
        width: 105px;
        height: 105px;
        border: dotted 1px #bfbfbf;
        text-align: center;
        margin: 10px 16px;
        border-radius: 4px;

        img {
            display: inline-block;
            width: 25px;
            height: 25px;
            margin-top: 33px;
            margin-bottom: 10px;
        }

        div {
            font-size: 13px;
            color: #999;
        }
    }

    .license-img {
        display: flex;
        flex-wrap: wrap;

        &-list {
            line-height: 32px;
            padding: 0 10px;
            background-color: #fff;
            display: flex;
            align-items: center;
            margin-right: 10px;
            margin-bottom: 10px;

            span {
                color: #1e88e5;
                cursor: pointer;
            }

            .line {
                width: 1px;
                height: 24px;
                background-color: #e6e6e6;
                margin: 0 6px;
            }
        }
    }

    &-export {
        padding: 30px 0 10px 30px;
        background-color: #fff;
    }

    &-scale {
        padding: 30px 0 10px 30px;
        background-color: #ededed;
    }

    &-tech {
        padding: 30px 0 10px 30px;
        background-color: #fff;
    }

    &-link {
        padding: 0 30px;
        background-color: #ededed;

        .ivu-form-item {
            margin-bottom: 0;
            line-height: 48px;

            /deep/ .ivu-form-item-label {
                font-size: 18px;
                padding: 0;
            }
        }
    }

    &-links {
        padding: 30px 0 10px 30px;
        background-color: #fff;
    }

    &-leader {
        padding: 0 30px;
        background-color: #ededed;
        position: relative;

        .ivu-form-item {
            margin-bottom: 0;
            line-height: 48px;

            /deep/ .ivu-form-item-label {
                font-size: 18px;
                padding: 0;
            }
        }

        .above {
            position: absolute;
            left: 240px;
            top: 10px;
        }
    }

    &-leaders {
        padding: 30px 0 10px 30px;
        background-color: #fff;
    }

    &-invoiceType {
        padding: 0 30px;
        background-color: #ededed;
        line-height: 48px;
        display: flex;
        justify-content: space-between;

        .ivu-checkbox-wrapper {
            margin: 0;
        }

        span {
            color: #ff0000;
            margin-left: 5px;
        }
    }

    &-invoices {
        padding: 30px 0 10px 30px;
        background-color: #fff;
    }
}

.tip {
    padding: 10px 16px 0;

    .red {
        font-size: 13px;
        color: #f00;
    }

    .txt1 {
        font-size: 13px;
        color: #000;
        font-weight: bold;
    }

    .txt2 {
        font-size: 13px;
        color: #999;
    }
}

.gap {
    height: 15px;
    background: #f7f7f7;
    width: 100%;
}


.top-title {
    padding: 10px 10px;
    align-items: center;
    padding-left: 15px;
    font-size: 15px;
    color: #333;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #e6e6e6;

    .line {
        content: "";
        width: 3px;
        height: 15px;
        background-color: #1e88e5;
        margin-right: 7px;
    }

    span {
        font-size: 15px;
        color: #f00;
    }

    &-left {
        flex: 1;
        text-align: right;
        display: flex;
        justify-content: flex-end;
        padding-right: 15px;
    }
}

.upload-btn2 {
    width: 105px;
    height: 105px;
    border: dotted 1px #bfbfbf;
    text-align: center;
    margin: 10px 16px;
    border-radius: 4px;
    position: relative;
    margin-left: 10px;

    img {
        position: absolute;
        width: 100%;
        height: 100%;
        margin: 0;
        top: 0;
        left: 0;
        z-index: 2;
    }

    .cover {
        position: absolute;
        background: rgba(0, 0, 0, 0.6);
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        margin: auto;
        z-index: 3;

        .icon {}
    }
}

.listPavilionDiv {
    background-color: #ffffff;
    width: 100%;
    color: #333333;
    font-size: 13px;
    padding: 10px;
    margin: 10px 0 0 0;
    box-shadow: 0px 1px 5px 0px rgba(0, 0, 0, 0.15);

}

.buttonCss {
    background-color: rgb(232, 243, 252);
    border-radius: 3px;
    border: solid 1px #1e88e5;
    color: #1e88e5;
}

.disFlex {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.changeCss {
    border-radius: 32px;
    border-radius: 32px;
    width: 70px;
    height: 27px;
    font-size: 15px;
    text-align: center;
    line-height: 27px;
}

.butButCss {
    padding: 0px 4px;
    background-color: #f7f7f7;
    line-height: 32px;
    font-size: 13px;
    text-align: center;
    min-width: 80px;
    letter-spacing: 0px;
    border-radius: 3px
}
</style>
